<template>
  <div class="liveset">
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label="测试环境地址:">
        <el-input v-model="form.testBaseUrl" disabled></el-input>
      </el-form-item>
      <el-form-item label="生产环境地址:" style="margin-bottom: 5px">
        <el-input v-model="form.proBaseUrl" disabled></el-input>
      </el-form-item>
      <div class="flex-row-start-center mgt-22" style="padding-left: 100px">
        <div style="text-align: center;">备注: 所有的接口请求,</div>
        <span class="red">请务必以 / 结尾</span> ,如请求token时,接口为{base_url}/v1/account/auth-token/,
        <span class="red">必须是以 / 结尾</span>。
      </div>
      <el-form-item label="APP ID:" required>
        <el-input v-model="form.app_id"></el-input>
      </el-form-item>
      <el-form-item label="Secret:" required style="margin-bottom: 5px">
        <el-input v-model="form.app_secret"></el-input>
      </el-form-item>
      <div class="flex-row-start-center" style="padding-left: 100px">
        <div style="text-align: center;">备注: 根据appid获取token,传入的参数appid和secret请登录后台,在</div>
        <span class="red">企业设置</span>-><span class="red">密钥管理</span> 获取,不懂可以看下图片链接
        <a href="https://www.youinsh.com/doc/apass-api.html#%E8%8E%B7%E5%8F%96token" target="_blank">https://www.youinsh.com/doc/apass-api.html#%E8%8E%B7%E5%8F%96token</a>
      </div>
      <div class="flex-row-start-center mgt-22" style="padding-left: 100px;margin-top: 5px">
        <div style="text-align: center;">注意: </div>
        <span class="red">APP ID 和 Secret是您访问直播系统API的凭证,请您妥善保管。</span>
      </div>
      <el-form-item label="选择环境" style="margin-bottom: 5px">
        <el-radio-group v-model="form.base_url" @change="changeBaseUrl">
          <el-radio :label="1">测试环境</el-radio>
          <el-radio :label="2">生产环境</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="第一步:" style="margin-bottom: 5px"></el-form-item>
      <div class="flex-row-start-center">
        <div class="bgc" style="width: 88px;padding: 10px 0" @click="getToken">获取token</div>
        <div style="margin-left: 15px" v-if="form.access_token">
          <el-input readonly v-model="form.access_token"></el-input>
        </div>
      </div>
      <el-form-item label="第二步:" style="margin-bottom: 5px"></el-form-item>
      <div class="bgc" style="width: 100px;padding: 10px 0" @click="getLiveList(currentPage)">获取直播列表</div>

    </el-form>
    <div class="live-all flex-row-start-center">
      <div class="live-list">
        <div>直播列表</div>
      </div>
      <div class="add-live" @click="createdLive">创建直播</div>
    </div>
      <div style="margin-top: 20px" class="alllive-list" v-loading="loading">
        <div class="alllive-tab">
          <div class="tab-one">序号</div>
          <div class="tab-one">直播封面</div>
          <div class="tab-one">直播名称</div>
          <div class="tab-one">直播时间</div>
          <div class="tab-one">直播状态</div>
          <div class="tab-one">操作</div>
        </div>
        <div class="alllive-body" v-for="(item,index) in liveList" :key="index">
          <div class="live-one">{{(currentPage-1) *11+(index+1)}}</div>
          <div class="live-one">
            <el-upload class="avatar-uploader" list-type="picture-card" action=""
              :auto-upload="false" :show-file-list="false"
              accept=".jpeg,.jpg,.png">
              <img v-if="item.image" width="100%" height="100%" :src="item.image" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
          <div class="live-one">{{item.title}}</div>
          <div class="live-one">{{item.start_time}} </div>
          <div class="live-one">{{item.live_status.info}}</div>
          <div class="live-one" style="display: flex">
            <div class="bgc" @click="goLive(item)">去直播</div>
          </div>
        </div>
      </div>
    <div class="page_box" v-if="liveList.length">
      <el-pagination background @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="10"
        layout="total, prev, pager, next"
        :total="totalPage">
      </el-pagination>
    </div>
    <!-- 创建直播 -->
    <el-dialog title="创建直播" :visible.sync="dialogVisible" width="70%">
      <add-live :baseUrl="this.base_url" @closeDiag="closeDiag"></add-live>
    </el-dialog>
    <!-- 去直播 -->
    <el-dialog title="去直播" :visible.sync="goVisible" width="70%">
      <go-live ref="golive" :baseUrl="this.base_url" :liveItem="liveItem" @closeDiag="closeGoDiag"></go-live>
    </el-dialog>
  </div>
</template>
<script>
// 处理时间格式转化
import getData from "../../../untils/getDate"
// 导入组件
import addLive from "./addLive.vue"
import goLive from "./goLive.vue"
export default {
  components:{
    addLive,
    goLive
  },
  data(){
    return {
      form: {
        testBaseUrl: "https://live.youinsh.com/saastestapi/",  // 测试环境地址
        proBaseUrl: "https://live.youinsh.com/livestreamapi/", // 生产环境地址
        app_id: "92890008131",           // 商户appid
        app_secret: "64a4c75ab3a63b1238f8c31aaa74bbc6",       // 商户密钥
        base_url: 1,          // 默认环境为测试环境
        access_token: "",     // 用户授权token
      },
      base_url:'',
      dialogVisible:false,   // 是否打开创建直播弹框
      goVisible:false,        // 是否打开直播列表去直播弹框
      liveList:[],           // 直播列表
      currentPage: 1,        // 当前页
      totalPage: 0,         // 总页数
      loading:false,
      liveItem:{},
    }
  },
  watch: {
    // 监听form.base_url 来判断展示的环境地址
    "form.base_url"(newVal) {
      if (newVal == 1) {
        this.base_url = "https://live.youinsh.com/saastestapi";
      } else if (newVal == 2) {
        this.base_url = "https://live.youinsh.com/livestreamapi";
      }
    },
    deep: true
  },
  created() {

    if (this.form.base_url == 1) {
      this.base_url = "https://live.youinsh.com/saastestapi";
    }
  },
  methods:{
    // 获取token
    getToken() {
      if(!this.form.app_id){
        this.$message({
          message: '请先填写APP ID',
          type: 'warning'
        });
        return
      }
      if(!this.form.app_secret){
        this.$message({
          message: '请先填写app_secret',
          type: 'warning'
        });
        return
      }
      this.$axios.post(`${this.base_url}/v1/account/auth-token/`, {
        app_id: this.form.app_id,
        app_secret: this.form.app_secret
      }).then(res => {
        if (res.status == 200 && res.data.code == 200) {
          this.form.access_token = res.data.result.access_token;
          this.$axios.defaults.headers.common["Authorization"] = "JWT " + this.form.access_token
        }else{
          this.$message.error(res.data.msg)
        }
      });
    },
    // 获取直播列表
    getLiveList(val){
      if(!this.form.access_token){
        this.$message({
          message: '请先获取token',
          type: 'warning'
        });
        return
      }
      this.loading = true
      this.$axios.get(`${this.base_url}/v1/course/system/list_course/?page=${val}`).then(res => {
        if (res.status == 200 && res.data.code == 200) {
          this.loading = false
          this.liveList = res.data.result
          this.totalPage = res.data.count;
          this.liveList.map(function(item,index){
            item.start_time = getData(item.start_time,true);
          })
        }else{
          this.$message.error(res.data.msg)
        }
      });
    },
    // 关闭创建直播弹框
    closeDiag(){
      this.dialogVisible = false
    },
     // 关闭去直播弹框
    closeGoDiag(){
      this.goVisible = false
    },
    // 选择环境
    changeBaseUrl(val) {
      this.form.base_url = val;
    },
    // 打开创建直播弹框
    createdLive(){
      if(!this.form.access_token){
        this.$message({
          message: '请先获取token',
          type: 'warning'
        });
        return
      }
      this.dialogVisible = true
    },
    // 打开去直播弹框
    goLive(item){
      this.goVisible = true
      this.liveItem = item
      this.$nextTick(()=>{
        this.$refs.golive.getData()  // 触发弹框页面的方法来传递数据
      })
    },
    // 点击分页触发
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getLiveList(this.currentPage)
    }
  }
}
</script>
<style lang="less" scoped>
/deep/ .el-input {
  width: 500px !important;
}
/deep/ .el-upload--picture-card{
  border: none;
}
.bgc{
  border: 1px solid #dedede;
  background: #409eff;
  padding: 10px 20px;
  color:#fff;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;
}
.liveset{
  .live-all{
    .live-list{
      flex: 1;
    }
    .add-live{
      width: 80px;
      border: 1px solid #dedede;
      background: #409eff;
      padding: 10px 0;color:#fff;
      text-align: center;
      border-radius: 5px
    }
  }
  .alllive-list{
    .alllive-tab{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 10px;
      .tab-one{
        padding: 0 10px;
        &:nth-child(1){
          width: 5%;
        }
        &:nth-child(2){
          width: 15%;
        }
        &:nth-child(3){
          width: 15%;
        }
        &:nth-child(4){
          width: 15%;
        }
        &:nth-child(5){
          width: 15%;
        }
      }
    }
    .alllive-body{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      border-bottom: 1px solid #dedede;
      .live-one{
        padding: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        &:nth-child(1){
          width: 5%;
        }
        &:nth-child(2){
          width: 15%;
        }
        &:nth-child(3){
          width: 15%;
        }
        &:nth-child(4){
          width: 15%;
        }
        &:nth-child(5){
          width: 15%;
        }
      }
    }
  }
  .page_box{
    margin-top: 20px;
    text-align: right;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/liveList/liveSet/index.vue